import { Type } from 'class-transformer';

export class ConveyanceBillingRuleAssignmentResultDto {
    @Type(() => Date)
    effectiveDate: Date;

    @Type(() => Date)
    effectiveThroughDate: Date;

    ruleCode: string;
    ruleCodeId: number;
    ruleDescription: string;
    billingRuleType: string;
    rateType: string;
    frequency: string;
    amount: number;
    billingRuleDescription: string;
    billingRuleId: number;
    cashOrAccrual: string;
    dueDay: number;

    @Type(() => Date)
    ruleEffectiveDate: Date;

    @Type(() => Date)
    ruleEffectiveThroughDate: Date;

    ruleType: string;
    subledger: string;
}
